import { RoleSchema } from "@/app/shared/services/volateq-api/api-schemas/role-schema";
import { CustomerSchema } from "@/app/shared/services/volateq-api/api-schemas/customer-schemas";
import { PlantSchema, SimplePlantSchema } from "./plant-schema";
import { PermissionSchema } from "./permission-schema";

export interface NotifiacationSettingsSchema {
  init_debug_phase: boolean;
  pickup_data: boolean;
  upgrade_product: boolean;
  retry_upload: boolean;
  analysis_failed: boolean;
  analysis_successful: boolean;
}

export interface UserProfileSchema {
  /** SUPER_ADMIN property */
  show_all_key_figures?: boolean;
  last_used_webapp_version: string;
  show_release_notes: boolean;
  hide_admin_features?: boolean;
}

export enum UserStateSchema {
  REGISTERED = "REGISTERED",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
  RESETTED = "RESETTED",
}

export enum UserAuthMethod {
  EMAIL = 0,
  TOTP = 1,
}

export interface UserSchema {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  profile: UserProfileSchema;
  notification_settings: NotifiacationSettingsSchema;
  last_login: string;
  created_at: string;
  invited_at: string;
  registered_at: string;
  roles: RoleSchema[];
  permissions: PermissionSchema[];
  state: UserStateSchema;
  is_locked: boolean;
  auth_method: UserAuthMethod;
  is_uploading: boolean;
  customer?: CustomerSchema;
  plants?: SimplePlantSchema[];
  shared_analyses?: { id: string, name: string }[];
}

export interface SimpleUserSchema {
  email: string;
  first_name: string;
  last_name: string;
}

export interface SimpleUserRoleSchema {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  roles: RoleSchema[];
  is_locked?: boolean;
}

/** Minimal user shape needed to render a user avatar (initials + identity). */
export interface AvatarUserSchema {
  id: string;
  first_name: string;
  last_name: string;
}